// extracted by mini-css-extract-plugin
export default {"progressBarTitle":"CardItemProgressBarText_progressBarTitle__PsCci","subTitle":"CardItemProgressBarText_subTitle__Vx0gM"};